import { css } from 'styled-components';

const menuStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export default menuStyles;
